export default function TemplateParams() {
  this.template = null;
  this.isActive = false;
  this.hasSelectorCheckbox = false;
  this.hasButtons = false;
  this.hasGroupTitle = false;
  this.onButtonsRender = null;
};